// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__4TXNT","contentSMALL":"modal_contentSMALL__ykiA8","contentLARGE":"modal_contentLARGE__Al-a0","contentLARGENS":"modal_contentLARGENS__S+wSx"};